import { render, staticRenderFns } from "./CAxAFFxClarificationsPage.vue?vue&type=template&id=6539a3f3"
import script from "./CAxAFFxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxAFFxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAFFxClarificationsPage.vue?vue&type=style&index=0&id=6539a3f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports